<template>
    <v-flex xs12 sm8 offset-lg2>
        <v-card p5 >
            <v-card-title>
                <div>
                    <span class="headline">Facturación</span><br>

                </div>
            </v-card-title>
            <sync-loader  :color="color"  v-if="spiner" style="margin-left: 45%; padding-top: 5%; padding-bottom: 5%"></sync-loader>
            <div class="sm12 lg12" style="padding: 20px" v-else>
                <v-card v-for="payment in payments" class="font-weight-regular m-2 row" >
                    <div style="width: 60%" class="pa-3"><span class="font-weight-medium">{{payment.courses.name}} </span></div>
                    <div style="width: 20%; text-align: center" class="pa-3">{{payment.total}}</div>
                    <div style="width: 10%; text-align: center" class="pa-3"v-if="payment.status === 'failure'"><i class="material-icons red--text">cancel</i></div>
                    <div style="width: 10%; text-align: center" class="pa-3"v-if="payment.status === 'success' || payment.status === 'approved'"><i class="material-icons green--text">check_circle</i></div>
                    <div style="width: 10%; text-align: center" class="pa-3"v-if="payment.status === 'pending'"><i class="material-icons blue--text">error</i></div>
                    <div style="width: 10%; text-align: center" class="pa-3"v-if="payment.status === 'refunded'"><i class="material-icons blue--text">settings_backup_restore</i></div>
                </v-card>
            </div>
        </v-card>
    </v-flex>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import SyncLoader from 'vue-spinner/src/PulseLoader.vue'
    export default {
        name: 'personalData',
        components: {
            SyncLoader
        },
        created(){
            this.getPaymentData()
        },
        data(){
            return {
                payments:[],
                color: '#F4511E',
                size:'',
                spiner: false,
            }
        },
        computed: {
            ...mapState,
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
        },
        methods:{
            getPaymentData:function () {
                var url = '/api/v1/setting/get/userOrder';
                this.spiner = true;
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    user_id:this.userId.id,
                }).then(response => {
                    this.payments = response.data;
                    this.spiner = false;
                });
            }
        }

    }
</script>